import React from 'react';
import { IonIcon } from '@ionic/react';
import {
  star, starHalf, starOutline,
} from 'ionicons/icons';

type Props = {
  stars: number;
};

const StarsReview: React.FC<Props> = ({ stars }) => {
  const starColor = stars !== 0 ? 'warning' : '';
  return (
    <>
      <IonIcon
        color={starColor}
        icon={stars > 0 ? (stars > 0 && stars < 1 ? starHalf : star) : starOutline} />
      <IonIcon
        color={starColor}
        icon={stars > 1 ? (stars > 1 && stars < 2 ? starHalf : star) : starOutline} />
      <IonIcon
        color={starColor}
        icon={stars > 2 ? (stars > 2 && stars < 3 ? starHalf : star) : starOutline} />
      <IonIcon
        color={starColor}
        icon={stars > 3 ? (stars > 3 && stars < 4 ? starHalf : star) : starOutline} />
      <IonIcon
        color={starColor}
        icon={stars > 4 ? (stars > 4 && stars < 5 ? starHalf : star) : starOutline} />
    </>
  )
  
};

export default StarsReview;